/* Cart drawer variant picker — snippets/cart-drawer-line-item.liquid
   The variant pill is a custom button + <ul> dropdown (styled to match the cart).
   Picking a different variant ADDS it to the cart as its own line — the
   original line stays (shoppers use this to build multi-variant bundles).
   Then the theme's existing cart-reload event re-renders the drawer.
   Event-delegated so it survives the AJAX re-injection. */
(function () {
  var DROPDOWN = '[data-variant-dropdown]';
  var TRIGGER = '[data-variant-trigger]';
  var OPTION = '[data-variant-option]';
  var busy = false;

  // Mirror the native quantity stepper's lockState(): flag the cart as busy so
  // section-cart-offers.js (watchNativeBusy) locks the checkout button for the
  // duration of the write. The trash/remove + variant-swap paths post change.js
  // directly and would otherwise leave checkout clickable against a stale cart
  // (delivery + free-gift lines still reflecting the not-yet-removed item). The
  // theme's showForm() clears cart--loading after the re-render; the offers JS
  // also has an 8s backstop so the flag can never freeze checkout.
  function setCartLoading() {
    var loader = document.querySelector('[data-cart-loading]');
    if (loader) loader.classList.add('cart--loading');
  }

  // Toggle the options list, pick a variant, or close on an outside click.
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest(TRIGGER);
    if (trigger) {
      toggleDropdown(trigger.closest(DROPDOWN));
      return;
    }
    var option = e.target.closest(OPTION);
    if (option) {
      selectOption(option);
      return;
    }
    closeAllDropdowns();
  });

  function toggleDropdown(dropdown) {
    if (!dropdown) return;
    var list = dropdown.querySelector('[data-variant-list]');
    var trigger = dropdown.querySelector(TRIGGER);
    if (!list) return;
    var wasOpen = !list.hidden;
    closeAllDropdowns();
    if (!wasOpen) {
      list.hidden = false;
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
    }
  }

  function closeAllDropdowns() {
    var open = document.querySelectorAll('[data-variant-list]:not([hidden])');
    for (var i = 0; i < open.length; i++) {
      open[i].hidden = true;
      var dd = open[i].closest(DROPDOWN);
      var t = dd && dd.querySelector(TRIGGER);
      if (t) t.setAttribute('aria-expanded', 'false');
    }
  }

  function selectOption(option) {
    if (busy) return;
    if (option.getAttribute('aria-disabled') === 'true') return;
    var dropdown = option.closest(DROPDOWN);
    var trigger = dropdown && dropdown.querySelector(TRIGGER);
    if (!trigger) return;
    var newId = option.dataset.variantId;
    closeAllDropdowns();
    // No-op if the chosen variant is the one already on this line.
    if (newId === trigger.dataset.currentVariant) return;
    addVariant(trigger, newId);
  }

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    closeAllDropdowns();
  });

  // X remove control (top-right of each line) — drops the whole line via
  // change.js qty:0, mirroring the variant-swap removal, then re-renders.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-cart-line-remove]');
    if (!btn) return;
    removeLine(btn);
  });

  function removeLine(btn) {
    if (busy) return;
    var lineKey = btn.dataset.lineKey;
    if (!lineKey) return;
    var row = btn.closest('[data-cart-item]');
    var loadbar = row && row.querySelector('[data-item-loadbar]');

    busy = true;
    btn.disabled = true;
    if (loadbar) loadbar.style.display = 'block';
    setCartLoading();

    postJSON(cartBase() + '/change.js', { id: lineKey, quantity: 0 })
      .then(function (cart) {
        reload(cart);
      })
      .catch(function (err) {
        // The rendered row can outlive its cart line (an earlier swap/removal
        // already dropped it, or a re-render raced the click) — change.js then
        // answers "no valid id or line parameter". Nothing left to remove:
        // treat as done and re-render instead of surfacing an error.
        if (staleLineError(err)) {
          reload();
          return;
        }
        btn.disabled = false;
        if (loadbar) loadbar.style.display = 'none';
        showError(friendlyError(err));
        reload();
        console.error('[cart-drawer] line remove failed', err);
      })
      .finally(function () {
        busy = false;
      });
  }

  // The Subtotal / You save rows sit above the checkout button and are always
  // visible, so refresh them on every cart change. (The checkout-button total
  // is [data-cart-final] and is updated separately by the theme.)
  document.addEventListener('theme:cart:change', function () {
    refreshBreakup();
  });

  function refreshBreakup() {
    var body = document.querySelector('[data-cart-breakup-body]');
    if (!body) return;
    var root = (window.theme && window.theme.routes && window.theme.routes.root_url) || '/';
    fetch(root + '?section_id=api-cart-price-breakup')
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var fresh = document.createElement('div');
        fresh.innerHTML = html;
        var content = fresh.querySelector('[data-api-content]');
        if (content) body.innerHTML = content.innerHTML;
      })
      .catch(function () { /* leave existing rows on failure */ });
  }

  function cartBase() {
    return (window.theme && window.theme.routes && window.theme.routes.cart) || '/cart';
  }

  // change.js's response when the target line key is absent from the cart
  // (row outlived its line: an earlier swap/removal already dropped it, or a
  // stale render raced the click).
  function staleLineError(err) {
    return /no valid id or line parameter/i.test((err && err.message) || '');
  }

  function addVariant(trigger, newId) {
    var base = cartBase();
    var row = trigger.closest('[data-cart-item]');
    var loadbar = row && row.querySelector('[data-item-loadbar]');

    busy = true;
    trigger.disabled = true;
    if (loadbar) loadbar.style.display = 'block';
    setCartLoading();

    // Add one unit of the chosen variant as its own line (add.js merges the
    // quantity if that variant is already in the cart). The original line is
    // deliberately left untouched — no removal leg, so there is no stale-key
    // failure mode here. Fetch the authoritative cart after the add so the
    // badge/footer/engine sync immediately; the settle loop verifies the
    // re-rendered body against it.
    postJSON(base + '/add.js', { id: newId, quantity: 1 })
      .then(function () {
        return fetch(base + '.js', { headers: { Accept: 'application/json' } })
          .then(function (res) { return res.json(); })
          .catch(function () { return null; });
      })
      .then(function (cart) {
        reload(cart);
      })
      .catch(function (err) {
        showError(friendlyError(err));
        reload();
        console.error('[cart-drawer] variant add failed', err);
      })
      .finally(function () {
        trigger.disabled = false;
        if (loadbar) loadbar.style.display = 'none';
        busy = false;
      });
  }

  // Cart API error bodies carry shopper-friendly text (e.g. stockout); network and
  // parse failures don't — show a generic message for those instead of raw noise.
  function friendlyError(err) {
    var msg = err && err.message;
    if (!msg || /unexpected token|failed to fetch|load failed|networkerror/i.test(msg)) {
      return 'Could not update cart, please try again';
    }
    return msg;
  }

  function showError(message) {
    var el = document.querySelector('[data-drawer="drawer-cart"] [data-form-errors]');
    if (!el) return;
    el.innerHTML = '<p>' + message + '</p>';
    el.style.display = 'block';
    clearTimeout(showError.timer);
    showError.timer = setTimeout(function () {
      el.style.display = 'none';
    }, 5000);
  }

  // change.js returns the updated cart — feed it to the theme so totals refresh,
  // then trigger the drawer re-render.
  function reload(cart) {
    if (cart) {
      document.dispatchEvent(new CustomEvent('theme:cart:change', { detail: { cart: cart }, bubbles: true }));
    }
    document.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true }));
    settleDrawer(0);
  }

  /* Shopify can render the drawer section from a cart replica a beat behind
     the write (the same lag theme.js's syncQuantities handles for quantity
     flickers) — the re-render after a swap/remove can paint the PRE-write line
     set, and nothing corrects it until a manual refresh. After each reload,
     verify the rendered rows against the authoritative cart and nudge another
     re-render (bounded retries, backoff) until they agree. */
  var settleTimer = null;
  function settleDrawer(attempt) {
    if (attempt >= 3) return;
    clearTimeout(settleTimer);
    settleTimer = setTimeout(function () {
      fetch(cartBase() + '.js', { headers: { Accept: 'application/json' } })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          if (drawerMatchesCart(cart)) return;
          document.dispatchEvent(new CustomEvent('theme:cart:change', { detail: { cart: cart }, bubbles: true }));
          document.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true }));
          settleDrawer(attempt + 1);
        })
        .catch(function () { /* verification only — leave current state */ });
    }, attempt === 0 ? 700 : 1400);
  }

  // The drawer agrees with the cart when every variant appears in the same
  // number of rendered rows as it has cart lines (paid rows + gift-card rows).
  function drawerMatchesCart(cart) {
    var container = document.querySelector('[data-line-items]');
    if (!container) return true; // no drawer body on this page — nothing to verify
    var domCounts = {};
    container.querySelectorAll('[data-cart-item][data-variant-id]').forEach(function (row) {
      var vid = row.getAttribute('data-variant-id');
      domCounts[vid] = (domCounts[vid] || 0) + 1;
    });
    var cartCounts = {};
    (cart.items || []).forEach(function (item) {
      var vid = String(item.variant_id);
      cartCounts[vid] = (cartCounts[vid] || 0) + 1;
    });
    var keys = Object.keys(domCounts).concat(Object.keys(cartCounts));
    for (var i = 0; i < keys.length; i++) {
      if ((domCounts[keys[i]] || 0) !== (cartCounts[keys[i]] || 0)) return false;
    }
    return true;
  }

  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) {
      if (!res.ok) {
        return res.json().catch(function () { return {}; }).then(function (data) {
          throw new Error(data.description || data.message || res.statusText);
        });
      }
      // A success body that isn't JSON (e.g. challenge page) shouldn't crash the
      // flow — the follow-up theme:cart:reload refetches the real state anyway.
      return res.json().catch(function () { return null; });
    });
  }

  // Intent-prefetch the cart. The first cart-icon open is otherwise cold: the
  // click runs /cart.js → api-cart-drawer-items → api-cart-subtotal serially
  // while the skeleton shows. Warming the moment the shopper signals intent
  // (hover/focus on desktop, touchstart on mobile) lets those fetches finish
  // before the click — same end state that makes the post-add "View Cart" popup
  // open instantly. Dispatches the theme's existing (but otherwise unfired)
  // theme:cart:init, which fetches the cart and, via theme:cart:change,
  // pre-renders the drawer body while it's still closed. Fires once per page —
  // the add-to-cart and quantity flows keep the cart warm after that.
  var CART_TOGGLE = '[data-drawer-toggle="drawer-cart"]';
  var cartWarmed = false;

  function warmCart(e) {
    if (cartWarmed) return;
    if (!e.target || !e.target.closest || !e.target.closest(CART_TOGGLE)) return;
    cartWarmed = true;
    document.dispatchEvent(new CustomEvent('theme:cart:init', { bubbles: true }));
  }

  document.addEventListener('mouseover', warmCart);
  document.addEventListener('focusin', warmCart);
  document.addEventListener('touchstart', warmCart, { passive: true });
})();
